import { FieldWithValue, FieldValueType, Field } from 'module/api/field/types';
import type { FilterFunction } from 'module/ui/components/molecules/field-filter/types';

export const getFieldValue =
  <T extends FieldValueType>(field: Field) =>
  (record: Record<string, unknown>): T | null => {
    const value = record?.[field.fieldName] as
      | FieldWithValue
      | FieldValueType
      | undefined;

    return value == null
      ? null
      : typeof value === 'object' && !Array.isArray(value)
        ? ((value as any as FieldWithValue).value as T)
        : (value as any as T);
  };

export const DEFAULT_FILTER_FUNCTION: FilterFunction = () => true;
